// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M15.5146 2L21 9.67954V22H3V2H15.5146ZM7 4H5V8H7V4ZM10.5 4H8.5V8H10.5V4ZM14 4H12V8H14V4Z"}}]};

const SdCard1FilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'sd-card-1-filled',
    ref,
    icon: element,
  },
));

SdCard1FilledIcon.displayName = 'SdCard1FilledIcon';

export default SdCard1FilledIcon;
